<div class="event">
  <div class="event-details">
    <h3 class="name">{{ event().name }}</h3>
    <span class="delegates">{{ event().delegates }} delegates</span>
    <div class="event-info">
      <span class="year">{{ event().year }}</span>
      <span class="phase">{{ event().phase }}</span>
      <span class="reporting-or-testing">{{ event().reportingOrTesting }}</span>
      <span class="bureau">{{ event().bureau }}</span>
    </div>
    @if (event().emissionPerDelegatesIndex; as emission) {
      <app-total-co2-saved
        [totalAmount]=" '' + emission"
        [description]="'Baseline index'"
        class="total-co--theme"
      ></app-total-co2-saved>
    }
  </div>
  <div class="event-controls">
    @if (eventIsNotCompleteRoute() || (event().topics | uncompletedTopics)) {
      <app-button
        class="event-bth--theme"
        [title]="buttons.continueButton"
        (buttonClick)="navToSkippedQuestion(event().id)"
      ></app-button>
    } @else {
      <app-button
        class="event-bth--theme"
        [title]="buttons.editEventButton"
        (buttonClick)="navToEventEvent(event().postEventId !== 0 ? event().postEventId : event().id)"
      ></app-button>
      @if (!isStatusReporting() && event().postEventId === 0) {
        <app-button
          class="event-bth--theme"
          [title]="buttons.createPostEventButton"
          (buttonClick)="createPostEventReport(event().id)"
        ></app-button>
      }
      <app-button
        class="event-bth--theme"
        [title]="buttons.getReportButton"
        (buttonClick)="getReport(event().postEventId !== 0 ? event().postEventId : event().id)"
      ></app-button>
      @if (isAdmin()) {
        <app-button
          class="event-bth--theme"
          [title]="'Recalculate'"
          (buttonClick)="recalculate(event().id)"
        ></app-button>
      }
    }
    <app-button
      [background]="'black'"
      [title]="buttons.deleteEventButton"
      (buttonClick)="deleteEvent(event())"
      class="event-bth--theme delete-button--theme"
    ></app-button>
  </div>
</div>
